module.exports = __webpack_public_path__ + "static/media/groups_bg.53c577ef.png";